// src/components/AiDashboard/AiMyNutritionStatus/AiUser/AiUserInputSeparator/AiMealFirebaseConfig.js


import { doc, getDoc } from 'firebase/firestore';
import GeminiNutritionService from './AiMealApiCall';


export async function loadApiKeysDoc(db, options = {}) {
  const {
    collection = 'chattxtaiuse',
    document = 'textuseai',
    field = 'apiKeys',
  } = options;

  if (!db) return null;

  const reference = doc(db, collection, document);
  const snapshot = await getDoc(reference);

  if (!snapshot.exists()) return null;

  const data = snapshot.data();
  return data && data[field] ? data[field] : null;
}


export function extractGeminiModelConfig(apiKeys, modelId = 'gemini-2.5-flash-lite') {
  const modelsNode = apiKeys && apiKeys.models ? apiKeys.models : {};
  const modelNode = modelsNode[modelId] || {};
  const apiNode = modelNode.api || {};


  const rawEndpoint = apiNode.endpoint;

  let modelPath = `models/${modelId}`;
  if (rawEndpoint) {
    const parts = String(rawEndpoint).split(':');
    if (parts[0]) {
      modelPath = parts[0];
    }
  }

  const baseUrl =
    apiNode.baseUrl || 'https://generativelanguage.googleapis.com/v1beta';

  const apiKey =
    apiKeys && typeof apiKeys.gemini === 'string' ? apiKeys.gemini : null;

  return {
    modelId,
    baseUrl,
    modelPath,
    rawEndpoint,
    apiKey,
  };
}

export async function createGeminiNutritionServiceFromFirestore(config) {
  const {
    db,
    modelId = 'gemini-2.5-flash-lite',
    allowedRoutes,
    overrides,
  } = config || {};

  const resolvedAllowedRoutes =
    allowedRoutes || { nutrition_ingress: ['gemini_egress'] };
  const resolvedOverrides = overrides || {};

  const defaultHttpClient =
    typeof resolvedOverrides.httpClient === 'function'
      ? resolvedOverrides.httpClient
      : (input, init) => fetch(input, init);

  try {
    const apiKeys = await loadApiKeysDoc(db);

    if (!apiKeys) {
      return new GeminiNutritionService({
        serviceName: 'GeminiNutritionService',
        model: `models/${modelId}`,
        endpoint: 'https://generativelanguage.googleapis.com/v1beta',
        apiKeyProvider: () => null,
        httpClient: defaultHttpClient,
        allowedRoutes: resolvedAllowedRoutes,
        ...resolvedOverrides,
      });
    }

    const modelConfig = extractGeminiModelConfig(apiKeys, modelId);

    return new GeminiNutritionService({
      serviceName: 'GeminiNutritionService',
      model: modelConfig.modelPath,       
      endpoint: modelConfig.baseUrl,        
      apiKeyProvider: () => modelConfig.apiKey,
      httpClient: defaultHttpClient,
      allowedRoutes: resolvedAllowedRoutes,
      ...resolvedOverrides,
    });
  } catch (error) {
    return new GeminiNutritionService({
      serviceName: 'GeminiNutritionService',
      model: `models/${modelId}`,
      endpoint: 'https://generativelanguage.googleapis.com/v1beta',
      apiKeyProvider: () => null,
      httpClient: defaultHttpClient,
      allowedRoutes: resolvedAllowedRoutes,
      ...(overrides || {}),
    });
  }
}
